import { render } from "./Investors.vue?vue&type=template&id=8bcb9e9a&scoped=true"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"

import "./Investors.vue?vue&type=style&index=0&id=8bcb9e9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcb9e9a"]])

export default __exports__